import React, { useEffect, useState } from "react";
import Navbar from "../../../Components/Navbar";
import PostQueriesSc from "./index.sc";
import { getElectronicFaqTypes } from "../../../api/FAQ/getElectronicFaqTypes";
import { useAuthContext } from "../../../hooks";
import { useForm } from "react-hook-form";
import { createGenralFaq } from "../../../api/FAQ/createGeneralFaq";

function Index() {
  const [genralFaq, setGeneralFaq] = useState<any>([]);
  const auth = useAuthContext();
  const fetchOrgGenralFaqType = async () => {
    await getElectronicFaqTypes(auth?.userInfo?.orgs[0]?.id)
      .then((e) => {
        console.log(e);
        setGeneralFaq(e);
      })
      .catch((e) => console.log(e));
  };
  useEffect(() => {
    fetchOrgGenralFaqType();
  }, []);
  const {
    register,
    handleSubmit,
    reset,
    setValue,
    formState: { errors },
  } = useForm();
  const handlereateGenralFaq = async (e: any) => {
    console.debug("data > ", e);
    await createGenralFaq(
      auth?.userInfo?.orgs[0]?.id,
      auth?.userInfo?.orgs_user_id[0],
      {
        ...e,
      }
    )
      .then((e) => {
        console.log(e);
      })
      .catch((err) => {
        console.log("====================================");
        console.log(err);
        console.log("====================================");
      });
  };
  console.log(auth?.userInfo?.orgs_user_id[0]);
  const onSubmit = async (e: any) => {
    console.log("I am Here", e);
    await handlereateGenralFaq(e);
    reset();
  };
  console.log(auth);
  return (
    <PostQueriesSc>
      <div className="queries-container">
        <div>
          <form onSubmit={handleSubmit(onSubmit)}>
            <div>
              <label>Choose the queries option:</label>
              <select
                className="form-select"
                aria-label="Default select example"
                {...register("faq_type_id", {
                  required: {
                    value: true,
                    message: "This is required",
                  },
                })}
              >
                <option>Select the option</option>
                {genralFaq?.map((data: any) => {
                  return (
                    <>
                      <option value={data?.faq_id}>{data?.faq_type}</option>
                    </>
                  );
                })}
              </select>
            </div>
            <div>
              <label>Details:</label>

              <div className="input-group">
                <span className="input-group-text">
                  Fill the concerns you have
                </span>
                <textarea
                  className="form-control"
                  aria-label="With textarea"
                  {...register("quest", {
                    required: {
                      value: true,
                      message: "This is required",
                    },
                  })}
                ></textarea>
              </div>
            </div>
            <div className="xbi4er-button">
              <button type="submit" className="btn btn-primary">
                Submit Insytix'er
              </button>
            </div>
          </form>
        </div>
      </div>
    </PostQueriesSc>
  );
}

export default Index;
